import { render } from "./TermsAndPrivacy.vue?vue&type=template&id=303049d8"
import script from "./TermsAndPrivacy.vue?vue&type=script&lang=js"
export * from "./TermsAndPrivacy.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__